import { render } from "./ImprimirEtiquetaNovo.vue?vue&type=template&id=0783d93f&scoped=true"
import script from "./ImprimirEtiquetaNovo.vue?vue&type=script&lang=js"
export * from "./ImprimirEtiquetaNovo.vue?vue&type=script&lang=js"

import "./ImprimirEtiquetaNovo.vue?vue&type=style&index=0&id=0783d93f&scoped=true&lang=css"

import exportComponent from "/woodpecker/src/github.com/Multpex/multpex.front.gestao/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0783d93f"]])

export default __exports__
import QPage from 'quasar/src/components/page/QPage.js';
import QImg from 'quasar/src/components/img/QImg.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QPage,QImg});
